var backbone = {
  exports: {}
};

export { backbone as b };
//# sourceMappingURL=backbone.js.map
